//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'VentilationBloodFlowRatio',
  data () {
    return {
      form: {
        v: '',
        q: ''
      },
      hasScore: false,
      disabled: false,
      descTxt: '',
      descMinTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = form.v / form.q
        self.hasScore = true
        if (result > 0.8) {
          self.descMinTxt = '通气过剩，血流不足，常见于肺栓塞'
        } else {
          self.descMinTxt =
            '通气不足，血流过剩，常见于慢性阻塞性肺疾病、慢性支气管炎、呼吸中枢抑制等'
        }
        return String(result.toFixed(1))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/VentilationBloodFlowRatio.vue